import { jsx as e } from "react/jsx-runtime";
const t = () => /* @__PURE__ */ e(
  "svg",
  {
    width: "10",
    height: "8",
    viewBox: "0 0 10 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "data-testid": "checkedmark-icon",
    children: /* @__PURE__ */ e(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.45461 7.94167L0.195939 4.683C-0.0653944 4.42167 -0.0653944 4.00033 0.195939 3.74033C0.455939 3.479 0.877272 3.479 1.13861 3.74033L3.45461 6.05633L8.81594 0.695C9.07594 0.435 9.49727 0.435 9.75861 0.695C10.0186 0.956333 10.0186 1.37767 9.75861 1.63767L3.45461 7.94167Z",
        fill: "white"
      }
    )
  }
);
export {
  t as CheckedmarkIcon
};
//# sourceMappingURL=index.es652.js.map
